<template>
  <div class="v-counter style-one">
    <button class="plusBtn" @click="increment"></button>
    <input type="text" size="25" :value="modelValue" class="count" />
    <button class="minusBtn" @click="decrement"></button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "QuantityCounter",
  props: {
    modelValue: {
      type: Number,
      default: 1,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const increment = () => {
      emit("update:modelValue", (props.modelValue || 1) + 1);
    };
    const decrement = () => {
      const next = (props.modelValue || 1) - 1;
      emit("update:modelValue", next < 1 ? 1 : next);
    };
    return {
      increment,
      decrement,
    };
  },
});
</script>
